export const styles = {
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'stretch',
    zIndex: 9000,
  },
  modalContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    backgroundColor: 'white',
    minWidth: '570px',
    maxWidth: '570px',
    overflowY: 'auto',
    height: '100%',
    paddingTop: '24px',
    transition: 'all 0.3s ease',
    '&::-webkit-scrollbar': {
      width: '8px',
    },
    '&::-webkit-scrollbar-track': {
      background: '#f1f1f1',
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#888',
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#555',
    },
    '@media (max-width: 570px)': {
      minWidth: '100%',
    },
    '@media (max-width: 495px)': {
      minWidth: '100vw',
    },
  },
  closeButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    width: '100%',
    padding: '0 32px 24px 32px',
    '@media (max-width: 495px)': {
      padding: '0 20px 24px 20px',
    },
  },
  closeButton: {
    cursor: 'pointer',
    width: '20px',
    height: '20px',
    background: 'none',
    border: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  closeIcon: {
    color: '#4F5B94',
    fontSize: '20px',
  },
  modalContent: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    height: '100%',
    padding: '0 32px',
    '@media (max-width: 495px)': {
      padding: '0 20px',
    },
  },
}
